import * as images from './images';

export const wallet = [
  { caption: '', src: images.skyminer1 },
  { caption: '', src: images.skyminer2 },
  { caption: '', src: images.skyminer3 },
  { caption: '', src: images.skyminer4 },
  { caption: '', src: images.skyminer5 },
  { caption: '', src: images.skyminer6 },
  { caption: '', src: images.skyminer7 },
  { caption: '', src: images.skyminer8 },
];

export const skyminer = [
  { caption: '', src: images.skyminer1 },
  { caption: '', src: images.skyminer2 },
  { caption: '', src: images.skyminer3 },
  { caption: '', src: images.skyminer4 },
  { caption: '', src: images.skyminer5 },
  { caption: '', src: images.skyminer6 },
  { caption: '', src: images.skyminer7 },
  { caption: '', src: images.skyminer8 },
];



// WEBPACK FOOTER //
// ./src/components/Skyminer/components/GalleryHDK/content.js